import React from 'react';
import Icon from '../ui/Icon';

export default function StatsCard({ title, value, subtitle, icon }) {
  return (
    <div className="card" style={{ position: 'relative', overflow: 'hidden' }}>
      <div className="p-6">
        <div className="flex items-start justify-between">
          <div>
            <p className="text-sm font-medium text-slate-500" style={{ textTransform: 'uppercase', letterSpacing: '0.05em' }}>
              {title}
            </p>
            <p className="text-3xl font-bold text-slate-900 mt-2">
              {value}
            </p>
            {subtitle && (
              <p className="text-sm text-slate-500 mt-1">{subtitle}</p>
            )}
          </div>
          {icon && (
            <div style={{ 
              padding: '0.75rem', 
              background: 'linear-gradient(135deg, var(--slate-900), var(--slate-700))',
              borderRadius: '0.75rem'
            }}>
              <Icon name={icon} size={24} style={{ color: 'var(--amber-400)' }} />
            </div>
          )}
        </div>
      </div>
      <div style={{
        position: 'absolute',
        bottom: '-1.5rem',
        right: '-1.5rem',
        width: '6rem',
        height: '6rem',
        background: 'var(--slate-50)',
        borderRadius: '50%',
        opacity: 0.5
      }} />
    </div>
  );
}